/// <amd-module name="Test/TestResultsView/Store/TestResultsViewStore" />
import { IViewContextData } from "Test/common-util/Common";
import {
    DataProviderErrorCodes,
    ITestResultTreeData,
    ITestResultViewContextPayload
} from "Test/common-util/Contracts/ViewContracts";
import { TestResultsReportActionsHub } from "Test/TestSummary/Actions/TestResultsReportActionsHub";
import { Store } from "VSS/Reflux/Store";

import { TestResultsViewActionHub, DetailsPaneMode, ITestResultViewDetails } from "Test/TestResultsView/Actions/TestResultsViewActionHub";

export interface ITestResultsViewState {
    detailsPaneMode: DetailsPaneMode;
    isLoading: boolean;
    context?: IViewContextData;
    errorMessage?: string;
    errorCode?: DataProviderErrorCodes;
    selectedTestResultTreeData?: ITestResultTreeData;
    runId?: number;
    resultId?: number;
    paneView?: string;
    isNoConfigRuns?: boolean;
    onlyRunFetch?: boolean;  
}

export class TestResultsViewStore extends Store {

    constructor(changedEvent: string,
        private _testResultSummaryActionHub: TestResultsReportActionsHub,
        private _testResultsViewActionHub: TestResultsViewActionHub) {
        super(changedEvent);
        this._setState();
        this._testResultsViewActionHub.onGridRowClicked.addListener(this._openDetailsPanel);
        this._testResultSummaryActionHub.onSummaryLoaded.addListener(this._onSummaryResultsLoaded);
        this._testResultsViewActionHub.openTestResultDetailsView.addListener(this._openViewWithDetailsMode);
        this._testResultsViewActionHub.onPivotChagnedInDetailsPane.addListener(this._onPivotChangedInDetailPane);
    }

    public dispose() {
        this._testResultsViewActionHub.onGridRowClicked.removeListener(this._openDetailsPanel);
        this._testResultSummaryActionHub.onSummaryLoaded.removeListener(this._onSummaryResultsLoaded);
        this._testResultsViewActionHub.openTestResultDetailsView.removeListener(this._openViewWithDetailsMode);
        this._testResultsViewActionHub.onPivotChagnedInDetailsPane.removeListener(this._onPivotChangedInDetailPane);
    }

    public getState(): ITestResultsViewState {
        return this._state;
    }

    private _setState(): void {
        this._state = {
            detailsPaneMode: DetailsPaneMode.Off,
            isLoading: true
        };
    }

    private _openDetailsPanel = (data: {testResultTreeData: ITestResultTreeData, mobileView: boolean}) => {
        if(!!data.mobileView) {
            this._state.detailsPaneMode = DetailsPaneMode.MobileView;
        }
        else {
            this._state.detailsPaneMode = DetailsPaneMode.HalfScreen;
        }

        this._state.selectedTestResultTreeData = data.testResultTreeData;
        this._state.runId = data.testResultTreeData.runId;
        this._state.resultId = data.testResultTreeData.resultId;
        this._state.paneView = "debug";
        this.emitChanged();
    }

    private _onSummaryResultsLoaded = (testResultContext: ITestResultViewContextPayload) => {
        this._state.isLoading = false;
        this._state.errorCode = testResultContext.errorCode;
        this._state.errorMessage = testResultContext.errorMessage;
        this._state.isNoConfigRuns = testResultContext.isNoConfigRuns;
        this.emitChanged();
    }

    private _openViewWithDetailsMode = (testResultDetails: ITestResultViewDetails) => {
        if(testResultDetails.isFullscreen){
            this._state.detailsPaneMode = DetailsPaneMode.FullScreen;
        }
        else{
            this._state.detailsPaneMode = DetailsPaneMode.HalfScreen;
            this._state.onlyRunFetch = true;
        }
        this._state.runId = testResultDetails.runId;
        this._state.resultId = testResultDetails.resultId;
        this._state.paneView = testResultDetails.paneView;
        this.emitChanged();
    }

    private _onPivotChangedInDetailPane = (pivotKey: string) => {
        this._state.paneView = pivotKey;
        this.emitChanged();
    }

    private _state: ITestResultsViewState;

}
